import axios from 'axios';

export function getCustomerPortalUrl(tenantId?: string) {
  const baseUrl = '/subscription/customerportalurl';
  const url = tenantId ? `${baseUrl}/${tenantId}` : baseUrl;
  return axios.get<{ customerPortalUrl: string }>(url);
}
